export default __webpack_public_path__ + "static/media/kichen_trolly.977901ac.jpeg";